import { PageTitle } from '../components/shared/PageTitle';
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router';
import { Spinner, Text, Link } from '@fluentui/react-components';
import { useT } from '../i18n';
import { fetchSharedEvidence } from '../api/shipment-evidence.api';

/** Página pública: evidencia compartida con un enlace (sin sesión). */
export default function SharedEvidencePage() {
  const t = useT().shipmentEvidence;
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';

  const q = useQuery({
    queryKey: ['shared-evidence', token],
    queryFn: () => fetchSharedEvidence(token),
    enabled: !!token,
    retry: false,
  });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12, padding: 16, maxWidth: 720 }}>
      <PageTitle>{t.public}</PageTitle>
      {!token && <Text>{t.invalid}</Text>}
      {q.isLoading && <Spinner label={t.loading} />}
      {q.isError && <Text>{t.invalid}</Text>}
      {q.data && (
        <>
          {q.data.label && <Text weight="semibold">{q.data.label}</Text>}
          <Text size={200}>{t.expiresOn} {new Date(q.data.expiresAt).toLocaleDateString()}</Text>
          {q.data.evidence.length === 0 && <Text>{t.noEvidence}</Text>}
          {q.data.evidence.map((e, i) => (
            <div key={i} style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
              <Text weight="semibold">{e.stage ? t.stageNames[e.stage as keyof typeof t.stageNames] ?? e.stage : t.stageLabel}</Text>
              {e.capturedAt && <Text size={200}>{t.takenAt} {new Date(e.capturedAt).toLocaleString()}</Text>}
              {e.url && <Link href={e.url} target="_blank" rel="noopener noreferrer">{t.open}</Link>}
            </div>
          ))}
        </>
      )}
    </div>
  );
}
